// extracted by mini-css-extract-plugin
export default {"about":"AboutContainer_about__pF2gV","spaceTop":"AboutContainer_spaceTop__19yLQ"};